import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const FailedCancelStoreCreditModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Crédito usado')} size="l">
      <Styles.MainContainer>
        <p>{t('El crédito en tienda ya fue utilizado por el cliente y no se puede anular.')}</p>
        <Button fullWidth onClick={onClose}>
          {t('Aceptar')}
        </Button>
      </Styles.MainContainer>
    </Modal>
  )
}

export default FailedCancelStoreCreditModal
